<template>
  <el-dialog
    :title="isEdit ? '编辑角色' : '新增角色'"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="formRules"
      label-width="80px"
    >
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="form.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <el-form-item label="角色编码" prop="roleCode">
        <el-input v-model="form.roleCode" placeholder="请输入角色编码" :disabled="isEdit" />
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="请输入描述"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addRole, updateRole } from '@/api/role'

export default {
  name: 'RoleForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submitLoading: false,
      form: this.getDefaultForm()
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    isEdit() {
      return this.formData && this.formData.id
    },
    formRules() {
      return {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        roleCode: [
          { required: true, message: '请输入角色编码', trigger: 'blur' },
          { pattern: /^[a-zA-Z_][a-zA-Z0-9_]*$/, message: '编码只能包含字母、数字和下划线', trigger: 'blur' }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.formData) {
          this.form = { ...this.formData }
        } else {
          this.form = this.getDefaultForm()
        }
      }
    }
  },
  methods: {
    getDefaultForm() {
      return {
        roleName: '',
        roleCode: '',
        description: '',
        status: 1
      }
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const api = this.isEdit ? updateRole : addRole
        api(this.form).then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.$emit('success')
        }).catch(() => {}).finally(() => {
          this.submitLoading = false
        })
      })
    },

    // 关闭弹窗
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.form = this.getDefaultForm()
    }
  }
}
</script>
